import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HeadlineContentModel } from '@libs/cms/models';
import { ContentBaseComponent } from '../content-base.component';

@Component({
  selector: 'ui-headline',
  templateUrl: './headline.component.html',
  styleUrls: ['./headline.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class HeadlineComponent extends ContentBaseComponent<HeadlineContentModel> {
}
